import { z } from 'zod';

import { createOffsetPaginationRequestQuerySchema } from './pagination';
import { PrimaryKeySchema, commaDelimitedList } from './utils';

export const SessionSchema = z.object({
  sessionId: PrimaryKeySchema,
  userId: PrimaryKeySchema.nullable(),
  apiTokenId: PrimaryKeySchema.nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type Session = z.infer<typeof SessionSchema>;

export const SessionsSchema = z.array(SessionSchema);

export type Sessions = z.infer<typeof SessionsSchema>;

export const SessionFiltersSchema = z
  .object({
    sessionIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
    userIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
    apiTokenIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
  })
  .merge(createOffsetPaginationRequestQuerySchema(z.enum(['createdAt'])));

export type SessionFilters = z.infer<typeof SessionFiltersSchema>;
